module.exports = __webpack_public_path__ + "media/latwy_select.f8106536.mp3";